module.exports = __webpack_public_path__ + "b81ba4f7d377d11253a18806e1b778d9.pdf";